import client from '../../client'
import {
  Contract,
  ContractId,
  MemberRequestParams,
  VerifyMemberRequestParams,
} from './types'

export * from './types'

export const memberRequest = async (params: MemberRequestParams) => {
  return await client.post(
    '/user/serviceForCorporation/requestToBeMember',
    params
  )
}

export const verifyMemberRequest = async (
  params: VerifyMemberRequestParams
) => {
  return await client.post(
    '/user/serviceForCorporation/verifyToBeMember',
    params
  )
}

export const getContract = async (contractId: ContractId) => {
  const { data } = await client.get<Contract>(
    `/user/serviceForCorporation/contracts/${contractId}`
  )
  return data
}
